import { Box, Flex, Section } from '@radix-ui/themes';

import { AvailableContentSection } from './AvailableContent/AvailableContentSection';
import { GlobalInfoSection } from './GlobalInformation/GlobalInfoSection';
import { SummarySection } from './Summary/SummarySection';
import { TechnicalDetailsSection } from './GlobalInformation/TechnicalDetailsSection';

export const PreviewTab = () => {
    return (
        <Section size={'1'}>
            <Section>
                <Flex gap={'8'} justify={'between'} align={'stretch'}>
                    <Box px={'5%'} width={'45%'}>
                        <SummarySection />
                    </Box>
                </Flex>
            </Section>

            <Section>
                <Flex px={'5%'} height={'100%'} justify={'between'}>
                    <GlobalInfoSection />
                    <TechnicalDetailsSection />
                </Flex>
            </Section>

            <Section>
                <AvailableContentSection />
            </Section>
        </Section>
    );
};
